import React, { useEffect, useState } from "react";

const backend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
const API = backend.endsWith("/api") ? backend : `${backend}/api`;

export default function PublicSupport() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${API}/public/settings`, { signal: controller.signal })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!controller.signal.aborted) setInfo(data); })
      .catch(() => {});
    return () => controller.abort();
  }, []);
  if (!info?.configured || !(info.support_email || info.support_whatsapp || info.site_notice)) return null;
  const digits = (info.support_whatsapp || "").replace(/\D/g, "");
  return <div className="ps-public-support" aria-label="Contact et assistance">
    {info.site_notice && <span>{info.site_notice}</span>}
    {info.support_email && <a href={`mailto:${info.support_email}`}>Assistance par e-mail</a>}
    {digits && <a href={`https://wa.me/${digits}`} target="_blank" rel="noopener noreferrer">Assistance WhatsApp ↗</a>}
  </div>;
}
